import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import { getAdminStatsApi } from '../../utils/api';

const card = { background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)', padding:'24px', display:'flex', alignItems:'center', gap:20 };

export default function AdminPanel() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => { getAdminStatsApi().then(({data})=>setStats(data)).finally(()=>setLoading(false)); }, []);

  if (loading) return <AdminLayout title="Dashboard"><div className="spinner"/></AdminLayout>;

  const CARDS = [
    { icon:'📚', val:stats.totalBooks,    label:'Books',   color:'#e8c547' },
    { icon:'👥', val:stats.totalUsers,    label:'Users',   color:'#2cb67d' },
    { icon:'🛒', val:stats.totalPurchases,label:'Sales',   color:'#ff8c42' },
    { icon:'💰', val:`₹${stats.totalRevenue}`, label:'Revenue', color:'#e53170' },
    { icon:'👁', val:stats.totalReads?.toLocaleString()||0, label:'Total Reads', color:'#a78bfa' },
  ];

  return (
    <AdminLayout title="Dashboard">
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(180px,1fr))', gap:16, marginBottom:32 }}>
        {CARDS.map(c=>(
          <div key={c.label} style={card}>
            <div style={{ width:48, height:48, borderRadius:12, background:`${c.color}18`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.4rem', flexShrink:0 }}>{c.icon}</div>
            <div>
              <div style={{ fontFamily:'var(--font-d)', fontSize:'1.8rem', fontWeight:700, color:'var(--text)', lineHeight:1 }}>{c.val}</div>
              <div style={{ color:'var(--text3)', fontSize:'0.75rem', marginTop:4, textTransform:'uppercase', letterSpacing:'0.07em', fontWeight:700 }}>{c.label}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Quick Actions */}
      <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)', padding:'24px', marginBottom:24 }}>
        <h2 style={{ fontFamily:'var(--font-d)', fontSize:'1.2rem', color:'var(--text)', marginBottom:16 }}>Quick Actions</h2>
        <div style={{ display:'flex', gap:12, flexWrap:'wrap' }}>
          <Link to="/admin/books/new" className="btn btn-gold btn-sm">+ New Book</Link>
          <Link to="/admin/books" className="btn btn-dark btn-sm">Manage Books</Link>
          <Link to="/admin/users" className="btn btn-dark btn-sm">View Users</Link>
        </div>
      </div>

      {/* Recent Books */}
      {stats.recentBooks?.length > 0 && (
        <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)', padding:'24px', marginBottom:24 }}>
          <h2 style={{ fontFamily:'var(--font-d)', fontSize:'1.2rem', color:'var(--text)', marginBottom:18 }}>Recent Books</h2>
          {stats.recentBooks.map((b,i)=>(
            <div key={b._id} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 0', borderBottom: i<stats.recentBooks.length-1?'1px solid var(--border)':'none', flexWrap:'wrap', gap:12 }}>
              <span style={{ fontWeight:700, color:'var(--text)', fontSize:'0.9rem' }}>{b.title}</span>
              <span className="badge badge-amber">{b.genre}</span>
              <span style={{ color:'var(--text3)', fontSize:'0.8rem' }}>{new Date(b.createdAt).toLocaleDateString()}</span>
              <div style={{display:'flex',gap:8}}>
                <Link to={`/admin/books/${b._id}/chapters`} className="btn btn-ghost btn-sm">Chapters</Link>
                <Link to={`/admin/books/${b._id}/edit`} className="btn btn-dark btn-sm">Edit</Link>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Recent Sales */}
      {stats.recentPurchases?.length > 0 && (
        <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)', padding:'24px' }}>
          <h2 style={{ fontFamily:'var(--font-d)', fontSize:'1.2rem', color:'var(--text)', marginBottom:18 }}>Recent Sales</h2>
          {stats.recentPurchases.map((p,i)=>(
            <div key={p._id} style={{ display:'flex', gap:16, alignItems:'center', padding:'12px 0', borderBottom:i<stats.recentPurchases.length-1?'1px solid var(--border)':'none', flexWrap:'wrap' }}>
              <span style={{fontWeight:700,color:'var(--text)',fontSize:'0.88rem',flex:1,minWidth:100}}>{p.user?.name||'?'}</span>
              <span style={{color:'var(--text3)',fontSize:'0.82rem'}}>{p.user?.email}</span>
              <span style={{color:'var(--text2)',fontSize:'0.88rem'}}>{p.book?.title||'Chapter'}</span>
              <span style={{fontWeight:700,color:'var(--success)'}}>₹{p.amount}</span>
              <span style={{color:'var(--text3)',fontSize:'0.78rem'}}>{new Date(p.createdAt).toLocaleDateString()}</span>
            </div>
          ))}
        </div>
      )}
    </AdminLayout>
  );
}
